import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getRoutePathname } from '../../../Handler/RouteHandler';
import ButtonComponent from '../../../Component/ButtonComponent/ButtonComponent';
import TextFieldComponent from '../../../Component/TextFieldComponent/TextFieldComponent';
import { Grid2 as Grid, Box, Slide, Fade } from '@mui/material';
import { initFormHandler } from "../../../Handler/FormHandler";
import ApiHandler from "../../../Handler/ApiHandler";
import { dispatch } from '../../../App';
import { SnackbarOpen } from '../../../Reducer/SnackBarReducer/SnackBarSlice';
import { AuthLogin } from '../../../Reducer/AuthReducer/AuthSlice';
import { useSelector } from 'react-redux';

function Login(props) {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = React.useState(false);
    const [inFadeIn, setInFadeIn] = React.useState(true);
    const isAdmin = window.location.pathname.startsWith('/authentication/admin');
    const [isSmallView, setSmallView] = React.useState(false);
    const screenReducer = useSelector(state => state.ScreenReducer);
    const [form, setForm] = React.useState({
        email: {
            name: 'email',
            label: 'Email',
            textHelper: 'Votre adresse email.',
            type: 'text',
            defaultValue: '',
            options: { validation: ['required', 'email'] }
        },
        password: {
            name: 'password',
            label: 'Mot de passe',
            textHelper: 'Votre mot de passe.',
            type: 'password',
            defaultValue: '',
            options: { validation: ['required'] }
        }
    });
    const handler = initFormHandler(form, setForm);
    React.useEffect(() => {
        handler.start();
    }, [handler]);

    React.useEffect(() => {
        setSmallView((screenReducer.screen === 'XS' || screenReducer.screen === 'SM'));
    }, [screenReducer.screen]);

    const login = () => {
        if (handler.checkError() < 1) {
            handler.setFormLoading(true);
            setIsLoading(true);
            let data = handler.getData();
            ApiHandler.post({
                route: 'authentication_login',
                data: { ...data, isAdmin: isAdmin }
            }, (response) => {
                if (response.status === 200) {
                    setTimeout(() => dispatch(AuthLogin(response.data)), 1500);
                } else if (response.status === 400) {
                    handler.setErrorApi(response.error);
                    handler.setFormLoading(false);
                    setIsLoading(false);
                } else {
                    dispatch(
                        SnackbarOpen({
                            text: response.error && response.error.message
                                ? response.error.message
                                : 'Une erreur inattendue s\'est produite.',
                            variant: 'error',
                        })
                    );
                    handler.setFormLoading(false);
                    setIsLoading(false);
                }
            });
        }
    };

    const Welcom = () => {
        return <Grid size={{ xs: 12, md: 6 }} style={{ position: 'relative' }}>
            <Fade in={inFadeIn} {...{ timeout: 1200 }}>
                <div>
                    <h2 style={{ fontFamily: 'Lato, Dancing Script', textAlign: 'center', fontSize: isSmallView ? 45 : 55, color: 'var(--greylight)', textShadow: '0px 0px 4px black', marginTop: isSmallView ? '' : '80px', marginBottom: 0 }}>
                        L'expertise de la peau
                    </h2>
                    <p style={{ textAlign: 'center', fontFamily: 'serif', fontSize: isSmallView ? 27 : 40, color: 'var(--greylight)', textShadow: '0px 0px 4px black', margin: 0 }}>
                        au service de votre bien être
                    </p>
                </div>
            </Fade>
        </Grid>
    }

    return (
        <Grid container spacing={2}>
            {isSmallView && <Welcom />}
            <Grid size={{ xs: 12, md: 6 }} style={{padding:'10px', boxShadow: 'rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px'}}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: '#ffffff00',
                        borderRadius: '40px',
                        width: isSmallView ? '80%' : '60%',
                        margin: 'auto'
                    }}
                >
                    <Slide direction="right" in={inFadeIn} {...{ timeout: 1000 }}>
                        <div>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                }}
                            >
                                <img src={'/asset/image/logo.webp'} alt="logo" style={{ width: isSmallView ? '80%' : '70%', margin: 'auto', borderRadius: '10%' }} />
                                <h2 style={{ color: 'var(--greylight)', textShadow: '0px 0px 4px black' }}>Login</h2>
                            </Box>
                            <Grid container spacing={2} sx={{ mt: 2 }}>
                                <Grid size={{ xs: 12, md: 12 }}>
                                    <TextFieldComponent id={'email'} handler={handler} onSubmit={login} />
                                </Grid>
                                <Grid size={{ xs: 12, md: 12 }}>
                                    <TextFieldComponent id={'password'} handler={handler} onSubmit={login} />
                                </Grid>
                            </Grid>
                            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                                <ButtonComponent
                                    onClick={login}
                                    label={'Se connecter'}
                                    loading={isLoading}
                                />
                            </Box>
                        </div>
                    </Slide>
                    <Slide direction="up" in={inFadeIn} {...{ timeout: 1000 }}>
                        <div style={{ width: '100%', maxWidth: '400px' }}>
                            <Box mt={2} width="100%" maxWidth={400}>
                                <Box sx={{ display: 'flex', justifyContent: 'center', color: 'var(--greylight)', textShadow: '0px 0px 4px black' }}>
                                   {!isAdmin && <p>
                                        Pas de compte : <span
                                            style={{ cursor: 'pointer', textDecoration: 'underline' }}
                                            onClick={() => {
                                                setInFadeIn(false);
                                                setTimeout(() => {
                                                    navigate(getRoutePathname("authentication_register"))
                                                }, 1000);
                                            }}> inscrivez-vous
                                        </span>
                                    </p>}
                                </Box>
                            </Box>
                        </div>
                    </Slide>
                </Box>
            </Grid>
            {!isSmallView && <Welcom />}
        </Grid>
    );
}

export default Login;
